import { createAction } from 'redux-actions';
import * as actions from './actions';

export const fetchTagsRequest = createAction(actions.FETCH_TAGS_REQUEST);
export const fetchTagsSuccess = createAction(actions.FETCH_TAGS_SUCCESS);
export const fetchTagsFailure = createAction(actions.FETCH_TAGS_FAILURE);

export const postTagRequest = createAction(actions.POST_TAG_REQUEST);
export const postTagSuccess = createAction(actions.POST_TAG_SUCCESS);
export const postTagFailure = createAction(actions.POST_TAG_FAILURE);
